import { IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { useDuplexerSubscription } from './use-duplexer-subscription';

const ENTITY_CHANGE_EVENTS: Array<'created' | 'updated' | 'deleted'> = ['created', 'updated', 'deleted'];

/**
 * Fires whenever a routine (PulseIdentity) changes anywhere — the Routines screen, a connector's card in
 * the chat, another device, or the routine itself.
 *
 * The last of those is why this exists rather than being a nicety that keeps two open cards in step. A
 * routine can stop itself: `PauseAndEscalateToUser` when it decides its own configuration is faulty, and
 * the credit-exhaustion auto-pause. Nothing the reader did produces those, so without this channel a
 * screen goes on showing a routine as running until something happens to remount it — and the switch is
 * then not a control, it is a stale claim.
 *
 * Callers refetch rather than patching a cache from the payload: the entity arrives, but the routines
 * list is an ENRICHED read (run counts, last run, the agent that worked it, the pause reason), and a
 * payload carrying only the entity would half-update a row into a state no read ever returns.
 */
export function useRoutinesDuplexer(onChange: () => void) {
  useDuplexerSubscription(IndividualsDuplexerChannel.PULSE_IDENTITY, () => onChange(), ENTITY_CHANGE_EVENTS);
}
